import { useTheme } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CheckIcon from '@mui/icons-material/Check'
import RemoveIcon from '@mui/icons-material/Remove'
import WarningIcon from '@mui/icons-material/Warning'
import CancelIcon from '@mui/icons-material/Cancel'
import { SELECTED_ROW_BORDER } from '../map-constants'

export { SELECTED_ROW_BORDER }

export const RELATIONSHIP_COLUMN_WIDTH = 180

// Row background tints — applied to non-active rows when a crop is hovered (transient)
const HOVER_COLORS = {
  'template-incompatible': 'rgba(244, 67, 54, 0.18)',
  'family-incompatible':   'rgba(244, 67, 54, 0.09)',
  'same-family':           'rgba(255, 152, 0, 0.12)',
  'template-companion':    'rgba(76, 175, 80, 0.18)',
  'family-companion':      'rgba(76, 175, 80, 0.09)',
  'neutral':               'transparent',
}

// Row background tints — applied when a crop is selected (persisted, darker)
const SELECTED_COLORS = {
  'template-incompatible': 'rgba(244, 67, 54, 0.38)',
  'family-incompatible':   'rgba(244, 67, 54, 0.20)',
  'same-family':           'rgba(255, 152, 0, 0.25)',
  'template-companion':    'rgba(76, 175, 80, 0.38)',
  'family-companion':      'rgba(76, 175, 80, 0.20)',
  'neutral':               'transparent',
}

// Per-type chip metadata — MUI icon, label, colours and count key for legend
export const RELATIONSHIP_DEFS = {
  'template-companion':    { label: 'Strong Species Companion', Icon: CheckCircleIcon, muiColor: 'success.main',    countKey: 'templateCompanion',    solid: true,  solidColor: '#388e3c', light: '#1b5e20', dark: '#a5d6a7', bg: 'rgba(76, 175, 80, 0.38)',   lightBg: 'rgba(76, 175, 80, 0.09)'   },
  'family-companion':      { label: 'Weak Family Companion',    Icon: CheckIcon,       muiColor: 'success.light',   countKey: 'familyCompanion',      solid: false, solidColor: null,      light: '#2e7d32', dark: '#c8e6c9', bg: 'rgba(76, 175, 80, 0.20)',   lightBg: 'rgba(76, 175, 80, 0.06)'   },
  'same-family':           { label: 'Same Family',              Icon: RemoveIcon,      muiColor: 'text.secondary',  countKey: 'sameFamily',           solid: false, solidColor: null,      light: '#e65100', dark: '#ffcc80', bg: 'rgba(255, 152, 0, 0.25)',   lightBg: 'rgba(255, 152, 0, 0.07)'   },
  'family-incompatible':   { label: 'Weak Family Inhibition',   Icon: WarningIcon,     muiColor: 'warning.main',    countKey: 'familyIncompatible',   solid: false, solidColor: null,      light: '#c62828', dark: '#ef9a9a', bg: 'rgba(244, 67, 54, 0.20)',   lightBg: 'rgba(244, 67, 54, 0.06)'   },
  'template-incompatible': { label: 'Strong Species Inhibition',Icon: CancelIcon,      muiColor: 'error.main',      countKey: 'templateIncompatible', solid: true,  solidColor: '#c62828', light: '#b71c1c', dark: '#ef9a9a', bg: 'rgba(244, 67, 54, 0.38)',   lightBg: 'rgba(244, 67, 54, 0.09)'   },
}

export const useMapCropsStyles = () => {
  const { palette } = useTheme()
  const isDark = palette.mode === 'dark'

  const relationshipMeta = Object.fromEntries(
    Object.entries(RELATIONSHIP_DEFS).map(([rel, def]) => [
      rel,
      { label: def.label, Icon: def.Icon, solid: def.solid, solidColor: def.solidColor, textColor: isDark ? def.dark : def.light },
    ])
  )
  relationshipMeta['neutral'] = null

  const legendItems = Object.entries(RELATIONSHIP_DEFS).map(([, def]) => ({
    Icon: def.Icon,
    label: def.label,
    solid: def.solid,
    solidColor: def.solidColor,
    bg: isDark ? def.bg : def.lightBg,
    textColor: isDark ? def.dark : def.light,
  }))

  return {
    HOVER_COLORS,
    SELECTED_COLORS,
    SELECTED_ROW_BORDER,
    RELATIONSHIP_COLUMN_WIDTH,
    relationshipMeta,
    legendItems,
  }
}
